import styled from "styled-components";
import Toast from "react-bootstrap/Toast";
import { Form } from "react-bootstrap";

export const PaymentFormContainer = styled(Form)`
  input:not([type="radio"]) {
    width: 200px;
  }
  fieldset {
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .input-group {
    width: 405px;
  }
`;

export const StyledIcon = styled.span`
  font-size: 1.2em;
`;

export const StyledTable = styled.table`
  tr td {
    vertical-align: middle;
  }
`;

export const StyledToast = styled(Toast)`
  .toast-header {
    background-color: ${
            (props) => {
                return props.status === "success" ? "#008C6B" : (props.status === "error" ? "#b20e0e" : "#FFA500")
            }
    };
    color: white;
  }
`;
